import { client } from "../client";
import type { PurchaseOrder } from "../types/purchase_orders.types";

export const createPurchaseOrder = async ({
	centerId,
	commands,
	deliveryType,
}: {
	centerId: number;
	commands: number[];
	deliveryType: "UPS" | "OTHER" | null;
}) => {
	const response = await client.post<PurchaseOrder>(
		`center/${centerId}/purchase/orders/`,
		{
			commands,
			deliveryType,
		},
	);
	return response.data;
};
